import React, { ButtonHTMLAttributes } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import BtnWithLoadStyle from './styles';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  name: string;
}

const BtnWithLoad: React.FC<IProps> = ({ loading = false, name, ...rest }) => {
  return (
    <>
      {loading ? (
        <BtnWithLoadStyle.Loading className="loading-btn">
          <FontAwesomeIcon icon={faSpinner} size="lg" />
        </BtnWithLoadStyle.Loading>
      ) : (
        <BtnWithLoadStyle.MainButton {...rest}>
          {name}
        </BtnWithLoadStyle.MainButton>
      )}
    </>
  );
};

export default BtnWithLoad;
